import React, { useState } from 'react'
import { ChevronDown } from 'lucide-react'

interface AccordionItemProps {
 title: string | React.ReactNode
 children: React.ReactNode
 defaultOpen?: boolean
}

interface AccordionProps {
 children: React.ReactNode
}

export const AccordionItem: React.FC<AccordionItemProps> = ({ 
 title, 
 children, 
 defaultOpen = false 
}) => {
 const [isOpen, setIsOpen] = useState(defaultOpen)

 return (
 <div className="border-b border-border">
 <button
 type="button"
 onClick={(e) => {
 e.preventDefault()
 e.stopPropagation()
 setIsOpen(!isOpen)
 }}
 className="w-full flex items-center justify-between py-4 px-4 text-left hover:bg-surface transition-colors"
 >
 <div className="flex-1 font-medium text-foreground">
 {title}
 </div>
 <ChevronDown
 className={`h-5 w-5 text-muted-foreground transition-transform duration-200 ${
 isOpen ? 'transform rotate-180' : ''
 }`}
 />
 </button>
 {isOpen && (
 <div className="px-4 pb-4 animate-in fade-in duration-200">
 {children}
 </div>
 )}
 </div>
 )
}

export const Accordion: React.FC<AccordionProps> = ({ children }) => {
 return (
 <div className="border border-border rounded-lg overflow-hidden bg-card">
 {children}
 </div>
 )
}

